import React from 'react';
export function SuspiciousBlockedTemplate() {
  return <div style={{
    fontFamily: 'Arial, sans-serif',
    maxWidth: '600px',
    margin: '0 auto'
  }} data-id="element-604">
      {/* Header with logo */}
      <div style={{
      textAlign: 'center',
      padding: '32px 0'
    }} data-id="element-605">
        <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hnodgoqduyba7n8dlqxg6c/d4d40573-a6d5-4127-bafb-e288840a0b5f/AISCO_WORKSPACE_MARCA_POSITIVO.svg" alt="Aisco Workspace" style={{
        height: '40px',
        display: 'inline-block'
      }} data-id="element-606" />
      </div>

      {/* Main content */}
      <div style={{
      backgroundColor: '#ffffff',
      padding: '40px 32px'
    }} data-id="element-607">
        <h1 style={{
        fontSize: '24px',
        fontWeight: '600',
        color: '#1f2937',
        marginBottom: '16px',
        marginTop: '0'
      }} data-id="element-608">
          Suspicious sign-in attempt blocked
        </h1>

        <p style={{
        fontSize: '16px',
        color: '#4b5563',
        lineHeight: '1.6',
        marginBottom: '24px'
      }} data-id="element-609">
          Hello,
        </p>

        <p style={{
        fontSize: '16px',
        color: '#4b5563',
        lineHeight: '1.6',
        marginBottom: '32px'
      }} data-id="element-610">
          We've blocked a suspicious sign-in attempt to your Aisco Workspace
          account. Our security systems detected unusual activity that didn't
          match your normal patterns.
        </p>

        <div style={{
        backgroundColor: '#fef2f2',
        padding: '20px',
        borderRadius: '8px',
        borderLeft: '4px solid #dc2626',
        marginBottom: '32px'
      }} data-id="element-611">
          <h3 style={{
          fontSize: '16px',
          fontWeight: '600',
          color: '#991b1b',
          marginTop: '0',
          marginBottom: '12px'
        }} data-id="element-612">
            🛡️ Security Alert
          </h3>
          <p style={{
          margin: '0',
          color: '#7f1d1d',
          fontSize: '14px',
          lineHeight: '1.6'
        }} data-id="element-613">
            <strong data-id="element-614">Your account is safe.</strong> We automatically blocked this
            attempt and no unauthorized access occurred.
          </p>
        </div>

        <div style={{
        backgroundColor: '#f9fafb',
        padding: '20px',
        borderRadius: '8px',
        border: '1px solid #e5e7eb',
        marginBottom: '32px'
      }} data-id="element-615">
          <h3 style={{
          fontSize: '14px',
          fontWeight: '600',
          color: '#6b7280',
          marginTop: '0',
          marginBottom: '12px',
          textTransform: 'uppercase',
          letterSpacing: '0.5px'
        }} data-id="element-616">
            Blocked Attempt Details
          </h3>
          <div style={{
          display: 'grid',
          gap: '8px'
        }} data-id="element-617">
            <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '14px',
            lineHeight: '1.6'
          }} data-id="element-618">
              <span style={{
              color: '#6b7280'
            }} data-id="element-619">
                Device:
              </span>
              <span style={{
              color: '#1f2937',
              fontWeight: '500'
            }} data-id="element-620">
                Unknown device
              </span>
            </div>
            <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '14px',
            lineHeight: '1.6'
          }} data-id="element-621">
              <span style={{
              color: '#6b7280'
            }} data-id="element-622">
                Location:
              </span>
              <span style={{
              color: '#1f2937',
              fontWeight: '500'
            }} data-id="element-623">
                Unknown location
              </span>
            </div>
            <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '14px',
            lineHeight: '1.6'
          }} data-id="element-624">
              <span style={{
              color: '#6b7280'
            }} data-id="element-625">
                Time:
              </span>
              <span style={{
              color: '#1f2937',
              fontWeight: '500'
            }} data-id="element-626">
                January 15, 2025 at 10:30 AM
              </span>
            </div>
            <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '14px',
            lineHeight: '1.6'
          }} data-id="element-627">
              <span style={{
              color: '#6b7280'
            }} data-id="element-628">
                Reason:
              </span>
              <span style={{
              color: '#dc2626',
              fontWeight: '500'
            }} data-id="element-629">
                Suspicious activity detected
              </span>
            </div>
          </div>
        </div>

        <div style={{
        backgroundColor: '#eff6ff',
        padding: '20px',
        borderRadius: '8px',
        borderLeft: '4px solid #2563eb',
        marginBottom: '32px'
      }} data-id="element-630">
          <h3 style={{
          fontSize: '16px',
          fontWeight: '600',
          color: '#1e40af',
          marginTop: '0',
          marginBottom: '12px'
        }} data-id="element-631">
            Recommended Actions
          </h3>
          <ul style={{
          margin: '0',
          paddingLeft: '20px',
          color: '#1e40af',
          fontSize: '14px',
          lineHeight: '1.8'
        }} data-id="element-632">
            <li data-id="element-633">Change your password immediately</li>
            <li data-id="element-634">Review your recent account activity</li>
            <li data-id="element-635">Enable two-factor authentication if not already active</li>
            <li data-id="element-636">Check for any unauthorized changes to your account</li>
          </ul>
        </div>

        {/* CTA Button */}
        <div style={{
        textAlign: 'center',
        margin: '32px 0'
      }} data-id="element-637">
          <a href="#" style={{
          display: 'inline-block',
          backgroundColor: '#dc2626',
          color: '#ffffff',
          padding: '14px 32px',
          borderRadius: '8px',
          textDecoration: 'none',
          fontSize: '16px',
          fontWeight: '600'
        }} data-id="element-638">
            Secure my account now
          </a>
        </div>

        <p style={{
        fontSize: '14px',
        color: '#6b7280',
        lineHeight: '1.6',
        marginTop: '32px',
        marginBottom: '0',
        textAlign: 'center'
      }} data-id="element-639">
          If you have concerns, contact our security team at{' '}
          <a href="mailto:security@aisco.com" style={{
          color: '#2563eb',
          textDecoration: 'none'
        }} data-id="element-640">
            security@aisco.com
          </a>
        </p>
      </div>

      {/* Footer */}
      <div style={{
      backgroundColor: '#f9fafb',
      padding: '24px 32px',
      borderTop: '1px solid #e5e7eb',
      textAlign: 'center'
    }} data-id="element-641">
        <p style={{
        fontSize: '12px',
        color: '#6b7280',
        lineHeight: '1.5',
        margin: '0'
      }} data-id="element-642">
          Aisco Europe S.A.U • Calle Playa de Riazor 22, 28042
          <br data-id="element-643" />
          Madrid, Spain
        </p>
      </div>
    </div>;
}